import { createPaymentLinkConstants, orderConstants } from "../../constants";

export function getOrderId(data) {
  return { type: orderConstants.GENERATE_ORDER_ID_REQUEST, data };
}
export function createPaymentLinkAction(data) {
  return { type: createPaymentLinkConstants.CREATE_PAYMENT_LINK_REQUEST, data };
}
